const TableUtil = {
  getColumnsScrollX: columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);

    return result;
  },

  getColumnNo: (rowIndex, pageSize, pageNum) => {
    const result = rowIndex + 1 + pageSize * (pageNum - 1);

    return result;
  },
};

export default TableUtil;
